import React, { createContext, useContext, useState, useEffect } from 'react'

export interface ActiveClassSession {
  classId: string
  className: string
  subject?: string
  day?: string
  period?: string
  timeStart?: string
  timeEnd?: string
  scheduleId?: string
  room?: string
  activatedAt?: string
}

interface ActiveClassContextType {
  activeClass: ActiveClassSession | null
  setActiveClass: (cls: ActiveClassSession) => void
  clearActiveClass: () => void
}

const STORAGE_KEY = 'pradnya_active_class_session'

const ActiveClassContext = createContext<ActiveClassContextType>({
  activeClass: null,
  setActiveClass: () => {},
  clearActiveClass: () => {},
})

export function ActiveClassProvider({ children }: { children: React.ReactNode }) {
  const [activeClass, setActiveClassState] = useState<ActiveClassSession | null>(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY)
      return saved ? JSON.parse(saved) : null
    } catch {
      return null
    }
  })

  const setActiveClass = (cls: ActiveClassSession) => {
    const sessionWithTime: ActiveClassSession = {
      ...cls,
      activatedAt: new Date().toISOString(),
    }
    setActiveClassState(sessionWithTime)
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(sessionWithTime))
    } catch (e) {
      console.warn('Gagal menyimpan sesi kelas aktif di localStorage:', e)
    }
  }

  const clearActiveClass = () => {
    setActiveClassState(null)
    try {
      localStorage.removeItem(STORAGE_KEY)
    } catch (e) {
      console.warn('Gagal menghapus sesi kelas aktif di localStorage:', e)
    }
  }

  return (
    <ActiveClassContext.Provider value={{ activeClass, setActiveClass, clearActiveClass }}>
      {children}
    </ActiveClassContext.Provider>
  )
}

export function useActiveClass() {
  return useContext(ActiveClassContext)
}
